module.exports = __webpack_public_path__ + "static/media/ordini4.889f6074.png";